<template>
  <div id="app-root">
    <div v-if="hasError" class="app-error-boundary">
      <div class="app-error-content">
        <h2 class="app-error-title">Something went wrong</h2>
        <p class="app-error-text">An unexpected error occurred. Please try again.</p>
        <button class="app-error-btn" @click="recover">Reload page</button>
      </div>
    </div>
    <router-view v-else/>
    <ForceUpdateOverlay />
  </div>
</template>

<script lang="ts">
    import ForceUpdateOverlay from '@/components/ForceUpdateOverlay.vue';
    import { startPresence } from '@/util/presence';
    export default {
        name: 'App',
        components: {
            ForceUpdateOverlay
        },
        data() {
            return {
                hasError: false
            };
        },
        created() {
            // this.$store.dispatch('Chat/get_location').then(location => {
            //     this.$store.commit("Chat/set_location", location.country ? [location.country.toLowerCase()] : ['ca', 'us']);
            // });

            // Resume presence tracking on a refresh-while-logged-in. Fresh
            // logins / tenant-switches are handled in the authenticate store's
            // activate_ut; this covers the case where that action never runs.
            try {
                if (this.$store.state.Authenticate.token) startPresence();
            } catch (e) { /* noop */ }
        },
        errorCaptured(err, vm, info) {
            // Log but don't crash the whole app for transient component errors
            // (e.g. PhotoSwipe init glitches, image decode errors). The old
            // behavior showed the full-page "Something went wrong" overlay
            // whenever a chat image failed to open. Swallow errors by default
            // and let Vue recover — real crashes will still surface in console.
            console.error('[App] Component error:', err, '\nComponent:', vm && vm.$options ? vm.$options.name : 'unknown', '\nInfo:', info);
            return false;
        },
        methods: {
            recover() {
                window.location.reload();
            }
        }
    };
</script>

<style scoped>
.app-error-boundary {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #f5f5f5;
    font-family: Roboto, sans-serif;
}
.app-error-content {
    text-align: center;
    padding: 40px;
}
.app-error-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}
.app-error-text {
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
}
.app-error-btn {
    padding: 10px 24px;
    background: #061D47;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    cursor: pointer;
}
.app-error-btn:hover {
    opacity: 0.85;
}
</style>
